import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Input, Tag, Switch } from "antd";

import toWav from "audiobuffer-to-wav";
import { useRecordAudioConnection } from "./model";
import { useDeviceLogConnection } from "../SelectDeviceLog/model";
import { loggerModel } from "../../entities/Logger";
import { virtualKoteachModel } from "../../entities/VirtualKoteach";

import "./Device.scss";

const Device = () => {
  const dispatch = useDispatch();
  const display_animation_fps = useSelector(
    virtualKoteachModel.selectDisplayAnimationFPS
  );

  const { sendMicToWebsocket, audioBuffer, audioHash } =
    useRecordAudioConnection();
  const {
    deviceId,
    loading,
    setDeviceId,
    connectToDevice: connectToDeviceLog,
    closeLogWebSocket,
  } = useDeviceLogConnection();

  const logger = useSelector(loggerModel.selectLoggerState);
  const isConnected = loggerModel.selectLoggerIsConnected(logger);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    closeLogWebSocket();
    // Update the deviceId state when the input value changes
    setDeviceId(event.target.value);
  };

  const onClickStartRecord = async () => {
    await sendMicToWebsocket(parseInt(deviceId));
  };

  const onClickDownloadRecord = () => {
    const wav = toWav(audioBuffer, {
      float32: true,
    });
    const wavBlob = new Blob([wav], { type: "audio/wav" });
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(wavBlob);
    downloadLink.download = `${audioHash}.wav`;

    downloadLink.click();
  };

  const isDefaultChecked = display_animation_fps === 30 ? true : false;

  const onFpsToggleClick = () => {
    const result_fps = display_animation_fps === 15 ? 30 : 15;
    dispatch(virtualKoteachModel.setDispalyAnimationFpsState(result_fps));
  };

  return (
    <div className="select_device">
      <div className="select_device__first_row">
        <div className="select_device__first_row__label">
          {"ID виртуального котича: "}
          <Input
            className="select_device__first_row__select"
            value={deviceId}
            onChange={handleInputChange}
          />
        </div>

        <div className="select_device__first_row__state">
          {"Статус: "}
          <Tag color={isConnected ? "green" : "red"}>
            {isConnected ? "Подключено" : "Нет соединения"}
          </Tag>
        </div>
      </div>

      <div className="select_device__second_row">
        {isConnected ? (
          <Button
            className="select_device__second_row__disconnect_button"
            type="primary"
            loading={loading}
            onClick={() => {
              closeLogWebSocket();
            }}
          >
            stop recording
          </Button>
        ) : (
          <Button
            className="select_device__second_row__connect_button"
            type="primary"
            loading={loading}
            onClick={() => {
              connectToDeviceLog();
              onClickStartRecord();
            }}
          >
            start recording
          </Button>
        )}
        <Button
          className="select_device__second_row__button"
          danger
          type="primary"
          loading={loading}
          onClick={onClickDownloadRecord}
        >
          download audio
        </Button>
      </div>
      <div className="select_device__third_row">
        {"Animation FPS: "}
        <Switch
          className="select_device__fps_switch"
          checkedChildren="30"
          unCheckedChildren="15"
          defaultChecked={isDefaultChecked}
          onChange={onFpsToggleClick}
        />
      </div>
    </div>
  );
};

export default Device;
